import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DocumentTextIcon from '@heroicons/react/outline/DocumentTextIcon';
import clsx from 'clsx';
import { SearchEntityType, } from '@tribeplatform/gql-client/types';
import { useRouter } from '@tribeplatform/react-sdk';
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar';
import { IconEmoji } from '../common';
import { T } from '../i18n';
import { SearchSubtitle } from './SearchSubtitle';
import { getSearchItemLink } from './utils';
export const SearchRowPreview = ({ hit, entityType, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    switch (entityType) {
        case SearchEntityType.member:
            return _jsx(Avatar, { size: "md", src: (_a = hit === null || hit === void 0 ? void 0 : hit.media) === null || _a === void 0 ? void 0 : _a.url }, void 0);
        case SearchEntityType.External:
            return _jsx(DocumentTextIcon, { className: "w-10 h-10 text-content-subdued" }, void 0);
        case SearchEntityType.space:
        case SearchEntityType.post:
            {
                const media = ((_c = (_b = hit === null || hit === void 0 ? void 0 : hit.in) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.__typename)
                    ? (_d = hit === null || hit === void 0 ? void 0 : hit.in) === null || _d === void 0 ? void 0 : _d.image
                    : hit === null || hit === void 0 ? void 0 : hit.media;
                if (((_e = media) === null || _e === void 0 ? void 0 : _e.__typename) === 'Emoji') {
                    return (_jsx("div", { className: "w-10 h-10 flex items-center justify-center", children: _jsx(IconEmoji, { text: (_f = media) === null || _f === void 0 ? void 0 : _f.text, size: "lg" }, void 0) }, void 0));
                }
                if (((_g = media) === null || _g === void 0 ? void 0 : _g.__typename) === 'Image') {
                    return _jsx(Avatar, { rounded: "md", size: "md", src: (_h = media) === null || _h === void 0 ? void 0 : _h.url }, void 0);
                }
            }
            return null;
        default:
            return null;
    }
};
export const SearchRow = ({ hit, entityType, spacing = 'md', }) => {
    const { Link } = useRouter();
    // The space for the post is deleted
    if (entityType === SearchEntityType.post && !(hit === null || hit === void 0 ? void 0 : hit.in)) {
        return null;
    }
    return (_jsxs(Link, { href: getSearchItemLink(hit), target: entityType === SearchEntityType.External ? '_blank' : '_self', className: clsx('flex items-center space-s-3', spacing === 'md' && 'px-6 py-5', spacing === 'sm' && 'px-2 py-2'), children: [_jsx("div", { className: "flex-shrink-0", children: _jsx(SearchRowPreview, { hit: hit, entityType: entityType }, void 0) }, void 0), _jsxs("div", { className: "flex-1 min-w-0", children: [_jsx("p", { className: "text-content", children: hit.title }, void 0), _jsx("p", { className: "text-content-subdued truncate", children: _jsx(SearchSubtitle, { hit: hit }, void 0) }, void 0)] }, void 0)] }, void 0));
};
export const SearchRowPage = ({ search, link, spacing = 'md' }) => {
    const { Link } = useRouter();
    if (!search) {
        return null;
    }
    return (_jsx(Link, { href: link, className: clsx('flex items-center space-s-3', spacing === 'md' && 'px-6 py-5', spacing === 'sm' && 'px-2 py-2'), children: _jsxs("div", { className: "flex-1 min-w-0", children: [_jsx("span", { className: "text-content", children: search }, void 0), _jsxs("span", { className: "text-content-subdued truncate", children: [' — ', _jsx(T, { id: "Search.Hints.SearchEverything", defaultMessage: "Search posts, {MEMBERS} and more" }, void 0)] }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=SearchRow.js.map